import { useHouseholdWorkflowTrackersContext } from '../contexts/useHouseholdWorkflowTrackersContext';
import {
  useOnTrackerComplete,
  type UseOnTrackerCompleteOptions,
} from './useOnTrackerComplete';

export type UseOnHouseholdWorkflowTrackerCompleteOptions = Omit<
  UseOnTrackerCompleteOptions,
  'loading' | 'sourceLabel' | 'trackers'
>;

export function useOnHouseholdWorkflowTrackerComplete(
  options: UseOnHouseholdWorkflowTrackerCompleteOptions
) {
  const { loading, trackers, snapshotStatus } =
    useHouseholdWorkflowTrackersContext();

  useOnTrackerComplete({
    ...options,
    // A scope reset removes trackers without completing them. Disable comparison
    // until the new snapshot (including an error) establishes its baseline.
    enabled: (options.enabled ?? true) && snapshotStatus !== undefined,
    loading,
    trackers,
    sourceLabel: 'household',
  });
}
